import React from "react";
import logo from "../image/jmif_logo2.svg";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="">
      <footer className=" bg-grey-normal grid lg:grid-cols-4 grid-cols-2 lg:gap-2 gap-x-2 gap-y-6 font-notoSans lg:px-36 mobileSm:px-8 px-4 py-8 text-sm border-t-8 border-secondary-dark">
        {/* grid 1 Contact information */}
        <div className="lg:hidden block col-span-2">
          <img
            src={logo}
            alt="logo"
            className=" w-[72px] h-[72px] content-center"
          />
        </div>
        <div className="text-text-lightActive  flex flex-col  gap-y-2 font-notoSans font-light md:text-sm text-xs ">
          <div className="lg:block hidden">
            <img src={logo} alt="logo" className=" w-24 h-24 content-center" />
          </div>
          <div className="flex gap-2">
            <svg
              className="md:w-[18px] w-4 md:h-[21px] h-[19px] stroke-primary-lightActive fill-none"
              viewBox="0 0 18 21"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.6569 14.6569C13.7202 15.5935 11.7616 17.5521 10.4138 18.8999C9.63275 19.681 8.36768 19.6814 7.58663 18.9003C6.26234 17.576 4.34159 15.6553 3.34315 14.6569C0.218951 11.5327 0.218951 6.46734 3.34315 3.34315C6.46734 0.218951 11.5327 0.218951 14.6569 3.34315C17.781 6.46734 17.781 11.5327 14.6569 14.6569Z"
                // stroke="#B9C0BB"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9Z"
                // stroke="#B9C0BB"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <span>Iligan City, Philippines</span>
          </div>
          <div className="flex gap-2">
            <svg
              className="md:w-[19px] w-[17px] md:h-[19px] h-[17px] stroke-primary-lightActive fill-none"
              // width="19"
              // height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 1H7L9 6L6.5 7.5C7.57096 9.67153 9.32847 11.429 11.5 12.5L13 10L18 12V16C18 16.5304 17.7893 17.0391 17.4142 17.4142C17.0391 17.7893 16.5304 18 16 18C12.0993 17.763 8.42015 16.1065 5.65683 13.3432C2.8935 10.5798 1.23705 6.90074 1 3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1"
                // stroke="#B9C0BB"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <span>+639771964178</span>
          </div>
          <div className="flex gap-2">
            <svg
              className="w-[21px] md:h-[19px] h-[18.3px] fill-primary-lightActive"
              // width="21"
              // height="19"
              viewBox="0 0 21 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.625 0C1.92881 0 1.26113 0.276562 0.768845 0.768845C0.276562 1.26113 0 1.92881 0 2.625V13.1381C0.00346963 13.832 0.281562 14.4964 0.77347 14.9858C1.26538 15.4752 1.93107 15.75 2.625 15.75H9.84375C10.0178 15.75 10.1847 15.6809 10.3078 15.5578C10.4309 15.4347 10.5 15.2678 10.5 15.0938C10.5 14.9197 10.4309 14.7528 10.3078 14.6297C10.1847 14.5066 10.0178 14.4375 9.84375 14.4375H2.625C2.33609 14.4375 2.05524 14.3422 1.826 14.1664C1.59676 13.9906 1.43195 13.744 1.35713 13.4649L8.75962 8.90925L10.5 9.95269L19.6875 4.44019V8.53125C19.6875 8.7053 19.7566 8.87222 19.8797 8.99529C20.0028 9.11836 20.1697 9.1875 20.3438 9.1875C20.5178 9.1875 20.6847 9.11836 20.8078 8.99529C20.9309 8.87222 21 8.7053 21 8.53125V2.625C21 1.92881 20.7234 1.26113 20.2312 0.768845C19.7389 0.276562 19.0712 0 18.375 0H2.625ZM7.49175 8.148L1.3125 11.9503V4.44019L7.49175 8.148ZM1.3125 2.90981V2.625C1.3125 2.2769 1.45078 1.94306 1.69692 1.69692C1.94306 1.45078 2.2769 1.3125 2.625 1.3125H18.375C18.7231 1.3125 19.0569 1.45078 19.3031 1.69692C19.5492 1.94306 19.6875 2.2769 19.6875 2.625V2.90981L10.5 8.42231L1.3125 2.90981Z"
                // fill="#B9C0BB"
              />
              <path
                d="M18.6992 16.1031C20.0248 16.1031 20.7821 14.9783 20.7821 13.4453V13.1696C20.7821 11.0644 19.215 9.1875 16.4325 9.1875H16.3866C13.6762 9.1875 11.8125 10.9725 11.8125 13.692V13.9729C11.8125 16.8263 13.6999 18.375 16.2199 18.375H16.2776C17.0573 18.375 17.6138 18.2779 17.9012 18.1453V17.1872C17.5796 17.3316 17.0179 17.4234 16.3524 17.4234H16.2947C14.5438 17.4234 12.9202 16.3892 12.9202 13.9388V13.7327C12.9202 11.5579 14.3089 10.1574 16.3853 10.1574H16.4377C18.4524 10.1574 19.698 11.5356 19.698 13.2103V13.3652C19.698 14.6449 19.2728 15.1896 18.8593 15.1896C18.5548 15.1896 18.3212 14.9953 18.3212 14.6383V11.7639H17.1321V12.5107H17.0927C16.9824 12.1196 16.6097 11.6839 15.8406 11.6839C14.8194 11.6839 14.1881 12.4123 14.1881 13.5214V14.2144C14.1881 15.3851 14.8312 16.0965 15.8419 16.0965C16.4601 16.0965 17.0179 15.7986 17.1727 15.2526H17.2292C17.3841 15.8038 18.039 16.1031 18.6992 16.1031ZM15.4796 13.7209C15.4796 13.0043 15.7776 12.6827 16.2317 12.6827C16.6215 12.6827 16.9824 12.9347 16.9824 13.6119V14.0936C16.9824 14.8457 16.6504 15.0701 16.2422 15.0701C15.7776 15.0701 15.4796 14.7879 15.4796 14.0201V13.7209Z"
                // fill="#B9C0BB"
              />
            </svg>

            <span>jamiatumarawi2000@gmail.com</span>
          </div>
        </div>
        {/* grid 2  Abour*/}
        <div className=" font-notoSans text-primary-lightHover flex flex-col gap-y-2">
          <p className=" font-semibold tracking-[0.02em] uppercase text-sm">
            About
          </p>
          <Link
            to="/about"
            className=" font-light hover:text-primary-lightActive"
          >
            About Us
          </Link>
          <Link
            to="/about"
            className=" font-light hover:text-primary-lightActive"
          >
            Mission & Vision{" "}
          </Link>
          <Link
            to="/about"
            className=" font-light hover:text-primary-lightActive"
          >
            Events{" "}
          </Link>
          <Link
            to="/about"
            className=" font-light hover:text-primary-lightActive"
          >
            News{" "}
          </Link>
        </div>
        {/* grid 3 */}
        <div className="text-primary-lightHover flex flex-col gap-y-2">
          <p className=" font-semibold tracking-[0.02em] uppercase">
            Admissions
          </p>

          <Link
            to="/admission"
            className=" font-light hover:text-primary-lightActive"
          >
            SHS Admission{" "}
          </Link>

          <Link
            to="/academics/tertiary-education"
            className=" font-light hover:text-primary-lightActive"
          >
            Courses
          </Link>
        </div>
        {/* grid 4 */}
        <div className="text-primary-lightHover flex flex-col gap-y-2">
          <p className=" font-semibold tracking-[0.02em] uppercase">
            Academics
          </p>
          <Link
            to="/academics/basic-education"
            className=" font-light hover:text-primary-lightActive"
          >
            Basic Education{" "}
          </Link>
          <Link
            to="/academics/tertiary-education"
            className=" font-light hover:text-primary-lightActive"
          >
            Tertiary Education{" "}
          </Link>
          <div className="flex gap-x-3 mt-4 items-center">
            {/* facebook logo */}
            <a
              href="https://www.facebook.com/profile.php?id=61550789474489"
              target="_blank"
              rel="noopener noreferrer"
              className="font-light hover:text-primary-lightActive" // Parent hover color
            >
              <svg
                width="13"
                height="20"
                viewBox="0 0 13 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 8V12H4V19H8V12H11L12 8H8V6C8 5.73478 8.10536 5.48043 8.29289 5.29289C8.48043 5.10536 8.73478 5 9 5H12V1H9C7.67392 1 6.40215 1.52678 5.46447 2.46447C4.52678 3.40215 4 4.67392 4 6V8H1Z"
                  stroke="currentColor" // Inherits color from parent <a>
                  strokeWidth="1.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>

            {/* social media 2 */}
            {/* <svg
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 7L9 11L15 17L19 1L1 8L5 10L7 16L10 12"
                stroke="#B9C0BB"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg> */}
          </div>
        </div>
      </footer>
      {/* footer banner */}
      <div className="w-full h-7 bg-primary-darkHover text-primary-normal flex justify-center items-center ">
        <p className="text-primary-light font-notoSans text-[10px]">
          (c) 2024 JMIF. All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer;
